import { axiosInstance } from "../../../axios/axiosInstance";

const API_SUPER_ADMIN_DASHBOARD_URL = "admin/dashboard";
const API_SUPER_ADMIN_DASHBOARD_INDEX_MODULE_LIST_URL = API_SUPER_ADMIN_DASHBOARD_URL + "/index";
const API_SUPER_ADMIN_DASHBOARD_ORDER_METRICS_MODULE_LIST_URL = API_SUPER_ADMIN_DASHBOARD_URL + "/orders-matrics";
const API_SUPER_ADMIN_DASHBOARD_SALES_METRICS_MODULE_LIST_URL = API_SUPER_ADMIN_DASHBOARD_URL + "/sales-matrics";

export const getSuperAdminDashboardIndex = () => {
  return axiosInstance.get(API_SUPER_ADMIN_DASHBOARD_INDEX_MODULE_LIST_URL);
};

export const getSuperAdminDashboardOrderMetrics = () => {
  return axiosInstance.get(API_SUPER_ADMIN_DASHBOARD_ORDER_METRICS_MODULE_LIST_URL);
};

export const getSuperAdminDashboardSalesMetrics = () => {
  return axiosInstance.get(API_SUPER_ADMIN_DASHBOARD_SALES_METRICS_MODULE_LIST_URL);
};


